import React from 'react';
import { faqs } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  // Split FAQs into two columns
  const midpoint = Math.ceil(faqs.length / 2);
  const leftColumn = faqs.slice(0, midpoint);
  const rightColumn = faqs.slice(midpoint);

  const FAQColumn = ({ items, startIndex }) => (
    <Accordion type="single" collapsible className="space-y-3">
      {items.map((faq, index) => (
        <AccordionItem 
          key={startIndex + index} 
          value={`item-${startIndex + index}`}
          className="bg-white rounded-xl border border-gray-200 overflow-hidden data-[state=open]:border-blue-300 data-[state=open]:shadow-md transition-all"
        >
          <AccordionTrigger className="px-5 py-4 text-left hover:no-underline group">
            <span className="font-medium text-[#1a365d] group-hover:text-blue-600 transition-colors pr-4 text-sm sm:text-base">
              {faq.question}
            </span>
          </AccordionTrigger>
          <AccordionContent className="px-5 pb-4 text-gray-600 text-sm leading-relaxed">
            {faq.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );

  return (
    <section id="faq" className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <HelpCircle className="h-8 w-8 text-blue-600" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#1a365d] mb-4">
            Common <span className="text-blue-500">Questions</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Everything you need to know about our bin rental services. Can't find your answer? Contact us directly.
          </p>
        </div>

        {/* Two Column FAQ Layout */}
        <div className="grid md:grid-cols-2 gap-6">
          <FAQColumn items={leftColumn} startIndex={0} />
          <FAQColumn items={rightColumn} startIndex={midpoint} />
        </div>

        {/* Still Have Questions */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <button
            onClick={() => {
              const element = document.querySelector('#contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-blue-600 font-semibold hover:text-[#1a365d] transition-colors underline underline-offset-4"
          >
            Get in touch with our team
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
